/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_StudioInputs */

const cs_enum_studio = /** @type {(inputs: Enum_StudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Garsoniéra`)
};

const en_enum_studio = /** @type {(inputs: Enum_StudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Studio`)
};

/**
* | output |
* | --- |
* | "Studio" |
*
* @param {Enum_StudioInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_studio = /** @type {((inputs?: Enum_StudioInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_StudioInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_studio(inputs)
	return cs_enum_studio(inputs)
});